<template>
    <v-card-text :class="`text-center ${secondColor}--text pb-0`" v-if="show && partialValue && consumption > 0">
        <div :class="['headline font-weight-bold mb-sm-2 text-no-wrap', { 'over-paid': isOverPaid }]">{{ money(total) }}</div>
        <div class="d-flex align-center justify-center text-caption text-no-wrap">
            <v-icon small :color="secondColor" class="mr-1">payment</v-icon>
            Valor parcial
            <span class="info-button ml-1" v-if="extraValue > 0">
                <span class="info-ping" v-if="idleValue > 0" />
                <v-btn icon x-small :color="idleValue > 0 ? 'deep-orange' : secondColor" title="Detalhamento do valor parcial" @click="dialog = true">
                    <v-icon small>info</v-icon>
                </v-btn>
            </span>
        </div>

        <v-dialog v-model="dialog" max-width="420">
            <v-card>
                <v-card-title class="secondary--text">
                    <v-icon left color="secondary">timer</v-icon>
                    Detalhamento do valor parcial
                </v-card-title>
                <v-card-text>
                    <div class="detail-section">
                        <div class="text-overline">Consumo</div>
                        <div class="d-flex justify-space-between">
                            <span>{{ consumption }} kWh x {{ money(priceKwh) }}</span>
                            <strong>{{ money(consumptionValue) }}</strong>
                        </div>
                    </div>
                    <div class="detail-section" v-if="idleValue > 0">
                        <div class="text-overline">Ociosidade</div>
                        <div class="d-flex justify-space-between">
                            <span>{{ minutesIdle }} min x {{ money(priceIdle) }}</span>
                            <strong>{{ money(idleValue) }}</strong>
                        </div>
                    </div>
                    <div class="detail-section" v-if="connectionValue > 0">
                        <div class="d-flex justify-space-between align-center">
                            <span class="text-overline">Desbloqueio</span>
                            <strong>{{ money(connectionValue) }}</strong>
                        </div>
                    </div>
                    <div class="detail-section">
                        <div :class="['d-flex justify-space-between', { 'red--text over-paid': isOverPaid }]">
                            <strong>Valor parcial total</strong>
                            <strong>{{ money(total) }}</strong>
                        </div>
                        <div class="text-caption red--text mt-1" v-if="isOverPaid">
                            O valor parcial ultrapassou a caução de {{ money(paidValue) }}.
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="secondary" @click="dialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card-text>
</template>

<script>
import { money } from "@/helpers/paymentAlerts";

// Valores já calculados pela API (plug.partialValue), com a mesma regra usada na cobrança
export default {
    props: {
        plug: {
            required: true,
        },
        secondColor: {
            required: true,
        },
        show: {
            required: true,
        },
    },

    data() {
        return {
            dialog: false,
        };
    },

    methods: {
        money,
    },

    computed: {
        partialValue() {
            return this.plug.partialValue;
        },
        consumption() {
            return this.partialValue.consumption.kwh;
        },
        priceKwh() {
            return this.partialValue.consumption.priceKwh;
        },
        consumptionValue() {
            return this.partialValue.consumption.value;
        },
        minutesIdle() {
            return this.partialValue.idle.minutes;
        },
        priceIdle() {
            return this.partialValue.idle.price;
        },
        idleValue() {
            return this.partialValue.idle.value;
        },
        connectionValue() {
            return this.partialValue.connection.value;
        },
        extraValue() {
            return this.idleValue + this.connectionValue;
        },
        total() {
            return this.partialValue.total;
        },
        paidValue() {
            return this.partialValue.paid;
        },
        isOverPaid() {
            return this.partialValue.overPaid;
        },
    },
}
</script>

<style scoped>
.info-button {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
}

.info-ping {
    position: absolute;
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    border-radius: 50%;
    background-color: #ff5722;
    opacity: 0.75;
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    pointer-events: none;
}

@keyframes ping {
    75%,
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

.over-paid {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
    50% {
        opacity: 0.5;
    }
}

.detail-section {
    background-color: #f1f1f1;
    border-radius: 12px;
    padding: 12px 16px;
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.87);
}
</style>
